/* Task 19: native-cookie presentation, cart safe space, and gallery viewport sizing.
   Consent choices, tracking APIs, Meta pixels and cart data are not modified. */
(() => {
  if (window.kukur19FollowupBound) return;
  window.kukur19FollowupBound = true;
  const config = document.currentScript?.dataset || {};
  const galleries = new Set();
  let currentBanner, frame;
  const bannerSize = new ResizeObserver(() => schedule());
  const gallerySize = new ResizeObserver(() => schedule());

  const compactBanner = banner => {
    if (!banner) return;
    for (const paragraph of banner.querySelectorAll('.shopify-pc__banner__body p')) {
      const policy = paragraph.querySelector('a[href*="/policies/privacy-policy"]');
      if (!policy || paragraph.classList.contains('k19-cookie-compact')) continue;
      const fullText = document.createElement('span');
      fullText.className = 'sr-only';
      for (const child of [...paragraph.childNodes]) if (child !== policy) fullText.append(child);
      const summary = document.createElement('span');
      summary.textContent = config.cookieLabel ? config.cookieLabel + '. ' : '';
      paragraph.replaceChildren(summary, policy, fullText);
      paragraph.classList.add('k19-cookie-compact');
    }
  };

  const dialogPrivacy = banner => {
    const dialog = document.querySelector('#shopify-pc__prefs__dialog');
    if (!dialog || dialog.querySelector('a[href*="/policies/privacy-policy"]')) return;
    const origin = banner?.querySelector('a[href*="/policies/privacy-policy"]');
    const url = origin?.href || config.privacyUrl;
    if (!url) return;
    const link = document.createElement('a');
    link.className = 'k19-dialog-privacy';
    link.href = url;
    link.textContent = origin?.textContent || config.privacyLabel;
    if (!link.textContent) return;
    const intro = dialog.querySelector('.shopify-pc__prefs__intro-main') || dialog.querySelector('header');
    intro?.append(link);
  };

  const sync = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    compactBanner(banner);
    dialogPrivacy(banner);
    if (banner !== currentBanner) {
      if (currentBanner) bannerSize.unobserve(currentBanner);
      currentBanner = banner;
      if (banner) bannerSize.observe(banner);
    }
    const bounds = banner?.checkVisibility() ? banner.getBoundingClientRect() : null;
    const height = bounds && bounds.bottom >= innerHeight - 2 ? Math.ceil(Math.max(0, innerHeight - bounds.top)) : 0;
    const root = document.documentElement;
    const value = height + 'px';
    if (root.style.getPropertyValue('--k19-cookie-height') !== value) root.style.setProperty('--k19-cookie-height', value);
    for (const gallery of document.querySelectorAll('.product-gallery')) {
      if (!galleries.has(gallery)) { galleries.add(gallery); gallerySize.observe(gallery); }
      const tall = innerWidth >= 750 && gallery.scrollHeight > innerHeight - 87 - height - 8;
      if (gallery.classList.contains('k19-gallery-tall') !== tall) gallery.classList.toggle('k19-gallery-tall', tall);
    }
    for (const gallery of galleries) if (!gallery.isConnected) { gallerySize.unobserve(gallery); galleries.delete(gallery); }
  };
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); };
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeType === 1 && (
      record.target.closest('#shopify-pc__banner,#shopify-pc__prefs,[data-product-section]') ||
      [...record.addedNodes,...record.removedNodes].some(node => node.nodeType === 1 && (
        node.matches('#shopify-pc__banner,#shopify-pc__prefs,.product-gallery') ||
        node.querySelector('#shopify-pc__banner,#shopify-pc__prefs,.product-gallery')
      ))
    ))) schedule();
  }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['style','class','hidden','open']});
  addEventListener('resize', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  document.addEventListener('shopify:section:load', schedule);
  sync();
})();
